export const DISTRACTION_COLORS = {
  focused: '#28a745',   // Green
  phone: '#dc3545',     // Red
  yawn: '#17a2b8',      // Cyan
  away: '#0000FF',      // Blue
  distracted: '#fd7e14',// Orange
  drowsy: '#ffc107',    // Yellow
  posture: '#e83e8c',   // Pink
  partial: '#6f42c1',   // Purple
  default: '#6c757d'    // Gray
};

export const DISTRACTION_COLORS_DARK = {
  ...DISTRACTION_COLORS,
  phone: '#ff6b6b',
  distracted: '#ff922b',
  drowsy: '#ffca2c'
};

export function getDistractionColor(type: string, isDark: boolean = false): string {
  const palette = isDark ? DISTRACTION_COLORS_DARK : DISTRACTION_COLORS;
  const key = type.toLowerCase();
  
  // Normalize keys
  if (key === 'confirmedpartial' || key === 'partial' || key === 'partial attendance') return palette.partial;
  if (key === 'not_focused' || key === 'notfocused') return palette.distracted;
  if (key === 'looking down' || key === 'lookdown') return palette.distracted; // Map to distracted or separate?
  if (key === 'turned away' || key === 'turnedaway') return palette.away;
  if (key === 'too far' || key === 'toofar') return palette.distracted;
  if (key === 'low quality' || key === 'poorquality') return palette.default;

  return (palette as any)[key] || palette.default;
}
